import React from 'react';


const Step3 = ({ onPrev, onSubmit, personalDetails, fileData }) => {

  const handlePrev = () => {
    onPrev();
  };

  const handleSubmit = () => {
    // Submit data to Firebase or perform necessary actions
    onSubmit(personalDetails, fileData);
  };
 
 // Static array of labels
 const staticLabels = [
  'fullName',
  'dob',
  'maritalStatus',
  'postalAddress',
  'phoneNo',
  'cellNo',
  'email',
  'nationality',
  'citizenship',
  'ethnicity',
  'homeLanguage',
  'idOrPassportNo',
  'visaPermitStatus',
  'churchAffiliation',
  'occupation',
  'highestEducationLevel',
  'disability',
  'otherInstitution',
  'otherInstitutionCourse',
  'howDidYouHear',
];

const labelMappings = {
  fullName: 'Full Name',
  dob: 'Date of Birth',
  maritalStatus: 'Marital Status',
  postalAddress: 'Postal Address',
  phoneNo: 'Phone Number',
  cellNo: 'Cell Number',
  email: 'Email',
  nationality: 'Nationality',
  citizenship: 'Citizenship',
  ethnicity: 'Ethnicity',
  homeLanguage: 'Home Language',
  idOrPassportNo: 'ID or Passport Number',
  visaPermitStatus: 'VISA/Permit Status',
  churchAffiliation: 'Church Affiliation',
  occupation: 'Occupation',
  highestEducationLevel: 'Highest Education Level',
  disability: 'Disability (Y/N)',
  otherInstitution: 'Other Institution',
  otherInstitutionCourse: 'Other Institution Course',
  howDidYouHear: 'How Did You Hear',
};
return (
  <div className="container">
    <div className="form-container">
      <h2>Step 3 of 3: Confirmation</h2>
      <h3>Confirm Your Details</h3>
      <h3 style={{ textDecoration: 'underline' }}>Personal Details</h3>
      <div>
        {staticLabels.map((fieldName, index) => (
          <div key={index}>
            <label style={{ fontWeight: 'bold' }}>{labelMappings[fieldName]}:</label>
            <p>{(personalDetails.formData && personalDetails.formData[fieldName]) || ''}</p>
          </div>
        ))}
      </div>

      <h3 style={{ textDecoration: 'underline' }}>Files Uploaded</h3>
      <p>
          <strong>ID Copy:</strong>{' '}
          <span style={{ color: fileData && fileData.idCopy ? 'green' : 'red' }}>
            {fileData && fileData.idCopy ? 'File Uploaded' : 'Not Uploaded'}
          </span>
        </p>
        <p>
          <strong>Matric Certificate:</strong>{' '}
          <span style={{ color: fileData && fileData.matricCertificate ? 'green' : 'red' }}>
            {fileData && fileData.matricCertificate ? 'File Uploaded' : 'Not Uploaded'}
          </span>
        </p>
        <p>
          <strong>RCL/CAT/Transcripts:</strong>{' '}
          <span style={{ color: fileData && fileData.transcripts ? 'green' : 'red' }}>
            {fileData && fileData.transcripts ? 'File Uploaded' : 'Not Uploaded'}
          </span>
        </p>
        <p>
          <strong>Proof Of Payment:</strong>{' '}
          <span style={{ color: fileData && fileData.proofOfPayment ? 'green' : 'red' }}>
            {fileData && fileData.proofOfPayment ? 'File Uploaded' : 'Not Uploaded'}
          </span>
        </p>
        <p>
          <strong>Pastoral Reference:</strong>{' '}
          <span style={{ color: fileData && fileData.pastoralReference ? 'green' : 'red' }}>
            {fileData && fileData.pastoralReference ? 'File Uploaded' : 'Not Uploaded'}
          </span>
        </p>

      <div className="buttons">
        <button onClick={handlePrev}>Previous</button>
        <button onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  </div>
  );
};

export default Step3;
